var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511 511",
    style: {
      enableBackground: "new 0 0 511 511"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M502.7,153.4c-1.2-26.3-5.4-44.4-11.5-60.1c-6.3-16.6-16-31.5-28.6-43.9c-12.4-12.6-27.4-22.4-43.8-28.5 C403,14.8,385,10.5,358.6,9.4c-26.5-1.3-34.9-1.5-102.2-1.5s-75.7,0.3-102.1,1.5c-26.3,1.2-44.4,5.4-60.1,11.5 c-16.6,6.3-31.6,16-43.9,28.6C37.7,61.8,28,76.8,21.8,93.3C15.7,109,11.4,127,10.2,153.4C9,179.9,8.7,188.3,8.7,255.5 s0.3,75.7,1.5,102.1c1.2,26.3,5.4,44.4,11.5,60.1c6.3,16.6,16.1,31.5,28.6,43.9c12.4,12.6,27.4,22.4,43.8,28.5 c15.8,6.1,33.8,10.4,60.1,11.5c26.4,1.2,34.8,1.5,102.1,1.5s75.7-0.3,102.1-1.5c26.3-1.2,44.4-5.4,60.1-11.5 c33.3-12.9,59.6-39.2,72.5-72.5c6.1-15.8,10.4-33.8,11.5-60.1c1.2-26.4,1.5-34.8,1.5-102.1S503.9,179.9,502.7,153.4z M458.1,355.7 c-1.1,24.2-5.1,37.3-8.5,46c-8.3,21.6-25.5,38.7-47,47c-8.7,3.4-21.9,7.5-46,8.5c-26.1,1.2-34,1.5-100.1,1.5s-74-0.3-100.1-1.5 c-24.2-1.1-37.3-5.1-46-8.5c-10.7-4-20.5-10.3-28.5-18.5c-8.2-8-14.5-17.7-18.5-28.5c-3.4-8.7-7.5-21.9-8.5-46 c-1.2-26.1-1.5-34-1.5-100.1s0.3-74,1.5-100.1c1.1-24.2,5.1-37.3,8.5-46c4-10.7,10.3-20.5,18.6-28.5c8-8.2,17.7-14.5,28.5-18.5 c8.7-3.4,21.9-7.5,46-8.5c26.1-1.2,34-1.5,100.1-1.5c66.2,0,74,0.3,100.1,1.5c24.2,1.1,37.3,5.1,46,8.5c10.7,4,20.5,10.3,28.5,18.5 c8.2,8,14.5,17.7,18.5,28.5c3.4,8.7,7.5,21.9,8.5,46c1.2,26.1,1.5,34,1.5,100.1S459.3,329.6,458.1,355.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.4,128.3c-70.3,0-127.3,57-127.3,127.3s57,127.3,127.3,127.3c70.3,0,127.3-57,127.3-127.3 S326.7,128.3,256.4,128.3z M256.4,338.1c-45.6,0-82.6-37-82.6-82.6s37-82.6,82.6-82.6c45.6,0,82.6,37,82.6,82.6 S302,338.1,256.4,338.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.5,123.3c0,16.4-13.3,29.7-29.7,29.7c-16.4,0-29.7-13.3-29.7-29.7c0-16.4,13.3-29.7,29.7-29.7 C405.1,93.5,418.5,106.8,418.5,123.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.cec32e0d0473241fef0ce247af571c85.svg";
export { ForwardRef as ReactComponent };